import { useApiQuery } from "app/modules/api-client";
import DurationService from "app/services/DurationService";

import { useAdvertiserActivityDataAndParams } from "../../common/hooks/useAdvertiserActivityDataAndParams";

export const useSearchCampaignsTableRows = (page: number, pageSize: number) => {
    const params = useAdvertiserActivityDataAndParams();
    const { from, to } = DurationService.getDurationData(params.duration).forAPI;

    const { data, isLoading, isError } = useApiQuery(
        {
            tag: "AdIntelligenceOverview",
            methodName: "adIntelligenceAdvertiserCampaignsSearchCampaignsList",
            options: {
                select: (response) => {
                    if (!response) {
                        return;
                    }
                    return {
                        totalCount: response.totalCount,
                        items:
                            response.data?.map((item) => ({
                                ...item,
                                key: item.url,
                            })) ?? [],
                    };
                },
            },
        },
        {
            country: params.country,
            key: params.key.split(","),
            from,
            to,
            page,
            pageSize,
        },
    );

    return { data: !isError ? data : undefined, isLoading, error: isError };
};
